@if (isModelBlocked) {
  <div class="flex flex-col gap-1.25">
    <div class="flex gap-1.25">
      <div class="main flex flex-col items-center w-full h-full">
        <div class="flex gap-0.15625">
          <span class="font-2 bold600">Portfolio performance</span>
          <span class="font-2 bold600 main-8">by group</span>
        </div>
        <div class="bg-black-3 w-full h-[28rem] rounded"></div>
      </div>
      <div class="main flex flex-col items-center w-full h-full">
        <div class="flex gap-0.15625">
          <span class="font-2 bold600">Proceeds</span>
          <span class="font-2 bold600 main-8">by exit size</span>
        </div>
        <div class="bg-black-3 w-full h-[28rem] rounded"></div>
      </div>
    </div>
    <div class="main flex flex-col items-center gap-1.25">
      <span class="font-2 bold600">Exit size & Holdings</span>
      <div class="bg-black-3 w-full h-[28rem] rounded"></div>
    </div>
    <div class="main flex flex-col items-center gap-1.25">
      <span class="font-2 bold600">Average Investment & Proceeds</span>
      <div class="bg-black-3 w-full h-[28rem] rounded"></div>
    </div>
  </div>
} @else if (options) {
  <div class="flex flex-col gap-1.25">
    <div class="flex justify-between gap-1.25">
      <div class="main flex flex-col items-center w-[49%]">
        <div class="flex gap-0.15625">
          <span class="font-2 bold600">Portfolio performance</span>
          <span class="font-2 bold600 main-8">by group</span>
        </div>
        <app-base-pie-chart class="w-full" [chartId]="'fs-total-proceeds-by-group'" [additionalOptions]="options.barProceedsByGroup"></app-base-pie-chart>
      </div>
      <div class="main flex flex-col items-center w-[49%]">
        <div class="flex gap-0.15625">
          <span class="font-2 bold600">Proceeds</span>
          <span class="font-2 bold600 main-8">by exit size</span>
        </div>
        <app-base-pie-chart class="w-full" [chartId]="'fs-total-proceeds-by-exit-size'" [additionalOptions]="options.pieProceedsBySize"></app-base-pie-chart>
      </div>
    </div>
    <div class="main flex flex-col items-center gap-1.25">
      <span class="font-2 bold600">Exit size & Holdings</span>
      <app-base-bar-chart class="w-full" [chartId]="'fs-exit-size-holding'" [additionalOptions]="options.barExitSize"></app-base-bar-chart>
    </div>
    <div class="main flex flex-col items-center gap-1.25">
      <span class="font-2 bold600">Average Investment & Proceeds</span>
      <app-base-bar-chart class="w-full" [chartId]="'fs-avg-inv-proceeds'" [additionalOptions]="options.barAvgInv"></app-base-bar-chart>
    </div>
  </div>

}
